import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String, copiedLabel: String }
  static targets = ["label"]

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = this.labelTarget.textContent
      this.labelTarget.textContent = this.copiedLabelValue
      setTimeout(() => {
        this.labelTarget.textContent = original
      }, 2000)
    })
  }
}
